import { useEffect, useRef, useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Sidebar } from "./sidebar";
import { Topbar } from "./topbar";
import { Toaster } from "../ui/toaster";
import type { WebModule } from "../../modules";

export function Shell({ modules, children }: { modules: WebModule[]; children: ReactNode }) {
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();
  const contentRef = useRef<HTMLElement>(null);

  // Ferme le tiroir mobile à chaque navigation.
  useEffect(() => {
    setNavOpen(false);
    contentRef.current?.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  // Bloque le défilement de fond quand le tiroir est ouvert.
  useEffect(() => {
    document.body.classList.toggle("is-nav-locked", navOpen);
    return () => document.body.classList.remove("is-nav-locked");
  }, [navOpen]);

  return (
    <div className={`shell${navOpen ? " is-nav-open" : ""}`}>
      <aside className="shell__sidebar" id="app-sidebar">
        <Sidebar modules={modules} />
      </aside>
      <div className="shell__backdrop" onClick={() => setNavOpen(false)} aria-hidden="true" />
      <header className="shell__topbar">
        <Topbar modules={modules} onMenu={() => setNavOpen((v) => !v)} navOpen={navOpen} />
      </header>
      <main className="shell__content" ref={contentRef}>
        {children}
      </main>
      <Toaster />
    </div>
  );
}
